import { render, staticRenderFns } from "./TakeawayVoucher.vue?vue&type=template&id=1945e5b9&scoped=true"
import script from "./TakeawayVoucher.vue?vue&type=script&lang=js"
export * from "./TakeawayVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945e5b9",
  null
  
)

export default component.exports